import { IonContent, IonPage, IonLoading, IonHeader } from '@ionic/react'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { client } from '../../services/client'
import AdminHeader from '../../components/header/admin-header'
import { associateSchema } from '../../admin/stylists-setup/stylists-setup.schema'
import { StylistsSetupTable } from '../../admin/stylists-setup/stylists-setup-table'

const fetchStylistsResponseSchema = z.object({
  result: z.array(associateSchema),
})

async function fetchStylists() {
  const response = await client.post('functions/page_associate').json()

  return fetchStylistsResponseSchema.parse(response).result
}

function useStylists() {
  const associatesQuery = useQuery({
    queryKey: [{ entity: 'stylists', scope: 'setup' }],
    queryFn: fetchStylists,
  })

  return {
    ...associatesQuery,
    data: associatesQuery.data ?? [],
  }
}

function StylistsSetupPage() {
  const associatesQuery = useStylists()

  const associates = associatesQuery.data

  return (
    <IonPage>
      <IonHeader>
        <AdminHeader title="Stylists" showMenu showInbox />
      </IonHeader>
      <IonContent className="ion-padding">
        <StylistsSetupTable
          data={associates}
          isLoading={associatesQuery.isLoading}
          disabled={associatesQuery.isLoading}
        />
      </IonContent>
      <IonLoading
        isOpen={associatesQuery.isLoading}
        message={'Please wait...'}
      />
    </IonPage>
  )
}

export default StylistsSetupPage
